export function buildBlogPostPayload(postData = {}) {
  const createdDate = postData.created_date || new Date().toISOString();

  return {
    title: postData.title,
    excerpt: postData.excerpt,
    content: postData.content,
    image: postData.image || 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=1200&h=800&fit=crop',
    author: postData.author,
    destination: postData.destination || '',
    category: postData.category || 'travel',
    featured: postData.featured ?? false,
    created_date: createdDate,
  };
}
